<template>
  <div class="card shadow">
    <div class="card-header border-0 dark">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0 sub_title">
            Lista de restaurantes
          </h3>
        </div>
        <div class="col text-right">
          <base-button type="primary btn_create" @click="ShowRestaurant">
            Crear restaurante
          </base-button>
          <CreateRestaurant/>
        </div>
      </div>
    </div>

    <div class="restaurants">
      <div class="col-12 row restaurant" v-for="(row, index) in tableData" :key="index" >
        <div class="col-4 row">
          <div class="col-10">
            <h4 class="name mb-0 text-sm tag-restaurant">Restaurante: <span>{{ row.name }}</span></h4>
            <h4 class="tag-restaurant">Telefono: <span>{{ row.phone }}</span></h4>
            <h4 class="tag-restaurant">Dirección: <span>{{ row.address }}</span></h4>
            <h4 class="tag-restaurant" v-for="(item,index) in row.City" :key="item.id" v-show="index ==='name'">
              Ciudad: <span>{{ item }}</span>
            </h4>
          </div>
          <div class="col-2 align-items-center">
            <div class="btn_icon_edit" @click="EditRestaurant(row.restaurant_id)"></div>
            <div class="btn_icon_delete" @click="DeleteRestaurant(row.restaurant_id)"></div>
          </div>
        </div>
        <div class="col-8">
          <div class="table-responsive table-flush">
            <table class="table align-items-center">
              <thead class="table-light">
              <th>Nombre</th>
              <th>Telefono</th>
              <th>Ciudad</th>
              <th>Direccion</th>

              <th></th>
              </thead>
              <tbody class="list">
              <tr v-for="(row, i) in row.children" :key="i" v-show="row.deletedAt === null" >
                <td scope="row" class="budget">
                  <div class="media align-items-center">
                    <div class="media-body">
                      <span class="name mb-0 text-sm">{{ row.name }}</span>
                    </div>
                  </div>
                </td>
                <td class="budget">
                  {{ row.phone }}
                </td>
                <td class="budget">
                  <div v-for="(item,i) in row.City" :key="item.id" v-show="i ==='name'">
                    {{ item }}
                  </div>
                </td>
                <td class="budget">
                  {{ row.address }}
                </td>
                <td class="budget">
                  <div class="btn_icon_edit" @click="EditSede(row.restaurant_id)"></div>
                  <div class="btn_icon_delete" @click="DeleteRestaurant(row.restaurant_id)"></div>
                </td>
              </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <base-pagination align="center" v-model="value" :page-count="page_count"></base-pagination>
  </div>

</template>

<script>
import {bus} from './bus-restaurant'
import CreateRestaurant from "./CreateRestaurant";
import {restaurant_service} from "../../services/restaurant/RestaurantService";
import _ from "lodash";
import swal from "sweetalert";

export default {
  name: "ShowRestaurant",
  components: {CreateRestaurant},
  data() {
    return {
      tableData: [],
      sedes: {},
      value: 1,
      page_count: 0
    }
  },
  watch: {
    'value': function () {
      restaurant_service.GetAllrestaurantPagination((this.value * 10) - 10)
    },
    'tableData': function () {
      if (this.tableData.length === 0) {
        restaurant_service.GetAllRestaurant()
      }
    }
  },
  methods: {
    ShowRestaurant() {
      bus.ShowRestaurant();
    },
    EditRestaurant(restaurant_id) {
      const u = _.find(this.tableData, function (item) {
        return item.restaurant_id === restaurant_id
      })
      bus.GetEditRestaurant(u)
    },
    EditSede(restaurant_id) {
      const u = _.find(this.sedes, function (item) {
        return item.restaurant_id === restaurant_id
      })
      bus.GetEditRestaurant(u)
    },
    DeleteRestaurant(restaurant_id) {
      var f = new Date()
      let day = f.getDate()
      let month = f.getMonth() + 1
      let year = f.getFullYear()
      let fecha = ''
      if (month < 10) {

        fecha = `${year}/0${month}/${day}`
      } else {
        fecha = `${year}/${month}/${day}`

      }
      const data = {
        restaurant_id: restaurant_id,
        deletedAt: fecha
      }
      swal("¿Seguro que lo desea eliminar?", {
        buttons: {
          cancel: "Cancelar",
          Aceptar: true,
        },
      })
          .then((value) => {
            switch (value) {
              case "Aceptar":
                restaurant_service.DeleteRestaurant(data)
                break;
            }
          });
    }
  },
  created() {
    restaurant_service.GetAllRestaurant()
    restaurant_service.GetAllSedes()
    bus.$on('GetAllRestaurant', (restaurants, value) => {
      //console.log(restaurants)
      this.tableData = restaurants
      this.page_count = Math.ceil(value / 10)
      this.value = 1
    })
    bus.$on('GetAllrestaurantPagination', (restaurants) => {
      this.tableData = restaurants
    })
    bus.$on('GetAllSedes', (response) => {

      this.sedes = response
    })
    bus.$on('DeleteRestaurant', (response) => {
      if (response.data) {
        restaurant_service.GetAllRestaurant()
        restaurant_service.GetAllSedes()
        swal({
          dangerMode: true,
          icon: "success",
          text: "Se Elimino Correctamente.",
          button: "Aceptar"
        })
      }else{
        restaurant_service.GetAllRestaurant()
        restaurant_service.GetAllSedes()
        swal({
          dangerMode: true,
          icon: "error",
          text: "¡No Se Elimino! Intenta de nuevo.",
          button: "Aceptar"
        })
      }

    })


  }
}
</script>

<style scoped>
.separator {
  padding: 10px;
}

@media screen and (min-width: 300px) and (max-width: 1001px) {
  .restaurants .restaurant > div {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>